import { Boxes } from "lucide-react";
import { useSetPageHeader } from "@/lib/page-header";
import { usePermissao } from "@/lib/use-permissao";
import { CartaoComDestaque } from "@/components/shared/CartaoComDestaque";
import { NoAccessBlock } from "@/components/shared/NoAccessBlock";
import { CartaoSalas } from "@/components/clinica/CartaoSalas";
import { CartaoEquipe } from "@/components/clinica/CartaoEquipe";
import { Selo } from "@/components/clinica/partes-do-cartao";

/** Hub da gestão da clínica (pedido do Jun): salas, equipe e, depois, o estoque. Cada cartão leva à
 *  página que já existe; o item do menu fica marcado nelas também. */
export function MinhaClinica() {
  useSetPageHeader({ title: "Minha clínica", subtitle: "Salas, equipe e estoque" }, []);
  const veSalas = usePermissao("agenda.view");
  const veEquipe = usePermissao("team.manage");

  if (!veSalas && !veEquipe) return <NoAccessBlock description="Minha clínica reúne salas e equipe, e você não tem acesso a nenhuma das duas." />;

  return (
    <div className="mx-auto grid w-full max-w-[1400px] gap-4 pb-10 sm:gap-5 md:grid-cols-2 xl:grid-cols-3">
      {veSalas && <CartaoSalas />}
      {veEquipe && <CartaoEquipe />}
      <CartaoComDestaque
        cor="#0ea5e9"
        icone={Boxes}
        titulo="Estoque"
        descricao="Insumos da clínica: entradas, baixas e aviso quando algo estiver acabando."
        canto={<Selo>Em breve</Selo>}
        apagado
      />
    </div>
  );
}
